import { Maybe } from '@csp/csp-common-model';
import { isNil } from 'lodash';
import { DataChangeEvidence } from '../model/DataChangeEvidence';

const toEnum = (hasEvidence: Maybe<boolean>): DataChangeEvidence => {
  /* Since BOOST-22427, we have to nilcheck this even though the type from DataChangeV1 says it's a defined boolean.
   * This is because the API can now return null for this field, which is not currently reflected the api specification.
   *
   * BOOST aims resolve this in a later increment, possibly introducing DataChangeV2.
   *
   * This is a workaround to handle the fact that the evidence field is no longer a binary value.
   */
  if (isNil(hasEvidence)) {
    return DataChangeEvidence.NOT_APPLICABLE;
  }

  return hasEvidence ? DataChangeEvidence.YES : DataChangeEvidence.NO;
};

export const DataChangeEvidenceMapper = {
  toEnum,
};
